export namespace Global {
    // アプリ（Unity）か判定して使う.
    export let isApp: boolean = false;
    export let kanaSerach: Function = () => { return; };

    // ロコモの開始、終わりの年月は残るので保持しておく.
    export let locomoStartYearMonth: string = '';
    export let locomoEndYearMonth: string = '';

    // ADLの開始、終わりの年月は残るので保持しておく.
    export let adlStartYearMonth: string = '';
    export let adlEndYearMonth: string = '';
}



// WEBPACK FOOTER //
// ./src/utils/global.tsx